import { createEmitter } from "ts_utils";
import { FbAuth } from "../../services/firebase/FbAuth";
import { UserManager } from "../UserManager";
import * as uih from "./UiHelper";

export class SignInView {
	private _ui:HTMLDivElement;
	
	private _emailInput:HTMLInputElement;
	private _passwordInput:HTMLInputElement;
	private _resetLink:HTMLAnchorElement;
	
	private _messageDiv:HTMLDivElement;
	
	private _signInBtn:HTMLButtonElement;
	private _newAccountBtn:HTMLButtonElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<SignInViewEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		this._init();
	}
	private _init():void {
		uih.hide(this._ui);
		
		this._emailInput = this._ui.querySelector("#siv-emailInput");
		this._passwordInput = this._ui.querySelector("#siv-passwordInput");
		this._resetLink = this._ui.querySelector("#siv-resetLink");
		
		this._messageDiv = this._ui.querySelector(".shacc-message");
		uih.hide(this._messageDiv);
		
		this._signInBtn = this._ui.querySelector("#siv-signInBtn");
		this._newAccountBtn = this._ui.querySelector("#siv-newAccountBtn");
	}
	
	public activate():void {
		this._emailInput.value = "";
		this._passwordInput.value = "";
		
		UserManager.get().hideLoadingOverlay();
		uih.hide(this._messageDiv);
		uih.show(this._ui);
		this._addListeners();
	}
	
	public deactivate():void {
		uih.hide(this._ui);
		this._removeListeners();
	}
	
	private _onResetLinkClick = async (e:MouseEvent):Promise<void> => {
		let email:string = this._emailInput.value;
		if (email.length < 1){
			this._messageDiv.innerHTML = "Please enter your email address to " +
				"send a reset link.";
			uih.show(this._messageDiv);
			return;
		}
		this._removeListeners();
		UserManager.get().showLoadingOverlay();
		
		try {
			this._messageDiv.innerHTML = "";
			await FbAuth.sendPasswordResetEmail(email);
			this._messageDiv.innerHTML = "Check your email and follow the "
				"instructions to reset your password.";
			uih.show(this._messageDiv);
		}
		catch (err){
			this._messageDiv.innerHTML = "Problem resetting your password.";
			uih.show(this._messageDiv);
			console.log(err);
		}
		finally {
			this._addListeners();
			UserManager.get().hideLoadingOverlay();
		}
	}
	
	private _onSignInBtnClick = async (e:MouseEvent):Promise<void> => {
		let email:string = this._emailInput.value;
		let password:string = this._passwordInput.value;
		
		this._removeListeners();
		UserManager.get().showLoadingOverlay();
		try {
			let user = await FbAuth.signInWithEmailAndPassword(email, password);
			if (user == null){
				this._messageDiv.innerHTML =
					"Unrecognized username or password";
				uih.show(this._messageDiv);
				this._addListeners();
				UserManager.get().hideLoadingOverlay();
			}
		}
		catch (err) {
			console.log(err);
			this._messageDiv.innerHTML = "Unrecognized username or password";
			uih.show(this._messageDiv);
			this._addListeners();
			UserManager.get().hideLoadingOverlay();
		}
	}
	
	private _onNewAccountBtnClick = (e:MouseEvent):void => {
		this._emitter.emit(SignInViewEvent.newAccountRequest);
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._resetLink.addEventListener("click", this._onResetLinkClick);
		this._signInBtn.addEventListener("click", this._onSignInBtnClick);
		this._newAccountBtn.addEventListener("click",
			this._onNewAccountBtnClick);
	}
	
	private _removeListeners():void {
		this._resetLink.removeEventListener("click", this._onResetLinkClick);
		this._signInBtn.removeEventListener("click", this._onSignInBtnClick);
		this._newAccountBtn.removeEventListener("click",
			this._onNewAccountBtnClick);
	}
}

export enum SignInViewEvent {
	canceled,
	newAccountRequest
}